import {PersonDto} from "./person.dto";
import {EntityStatusEnum} from "features/core/shared/entity/enum/entity-status.enum";
import {DtoDetail} from "features/core/shared/dto/dto.detail";
// TYPE ONLY (GK1): cd is a foreign module here - a runtime import would violate the no-cross-module
// import rule. cd.Contact data itself is always accessed via MvsCoreService.getCrudService('cd.Contact').
import type {ContactDto} from "features/feature-core/cd/model/dto/entity/contact.dto";

export class PersonContactDto extends DtoDetail{

    public personDto? : PersonDto;
    public personDtoId : number;
    public personDtoName : string;
    public entityStatus: EntityStatusEnum;
    public startDate: Date;
    public endDate: Date;
    public contactDto? : ContactDto;
    public contactDtoId : number;
    public contactDtoName : string;

}
